export default {
    headerLabel: 'Find companies',
    companyListLabel: 'Companies',

    errors: {
        unknownError: 'Oh no! An unknown error occurred!',
        noCompaniesFound: 'No companies found',
    },
};
